module.exports = __webpack_public_path__ + "media/images/share_img_fb-753d351b4cea77ec6766d3c7d15516cb.png";